import { useState, useRef, type FormEvent } from "react"
import { Button } from "react-bootstrap"
import { useUploadNotes } from "@apis/accounts/useAccounts"
import { toast } from "sonner"
import { Loader2 } from "lucide-react"

// TODO: Add form wrapper once decision has been made on which form pattern to use
// TODO: Update styling to tailwind
// TODO: Write Specs

const FileUploadForm = () => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<File | null>(null)
  const { mutate, isPending } = useUploadNotes()

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!file) return toast.info("Please choose a file to upload first")

    const formData = new FormData()
    formData.append("file", file)

    mutate(formData, {
      onSuccess: () => toast.success("Successfully uploaded File!"),
      onError: (error) => toast.error(`Error uploading File! ${error}`),
    })

    // Verificamos que la referencia exista
    if (inputFileRef.current) {
      inputFileRef.current.value = ""
    }
    setFile(null)
  }

  return (
    <div className="border border-secondary shadow bg-white p-4 rounded mb-5">
      <h3 className="px-2">File Upload</h3>
      <div className="w-75 p-2">
        <p className="font-weight-bold mb-1">
          File must be in .csv format. Column headers and data required are
          &apos;account_id&apos; and &apos;note&apos;.
        </p>
        <form onSubmit={handleSubmit}>
          <label
            className="form-label d-block"
            htmlFor="mass-notate-file-input"
          >
            Attach File
          </label>
          <input
            className="form-control border border-dark"
            ref={inputFileRef}
            id="mass-notate-file-input"
            type="file"
            accept=".csv"
            onChange={(e) => {
              // Verificamos que hay archivos seleccionados
              if (e.target.files && e.target.files.length > 0) {
                setFile(e.target.files[0])
              }
            }}
          />
          <Button
            type="submit"
            className="mt-4 btn btn primary w-25"
            disabled={!file || isPending}
          >
            {isPending ? <Loader2 className="animate-spin" /> : "Upload File"}
          </Button>
        </form>
      </div>
    </div>
  )
}

export default FileUploadForm
